import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0m6.34 12.77-4.21 3.45a1 1 0 0 1-1.63-.78v-.54a.25.25 0 0 0-.13-.22.27.27 0 0 0-.26 0L9.55 16.4A1 1 0 0 1 8 15.56V8.43a1 1 0 0 1 1.55-.83l2.56 1.71a.27.27 0 0 0 .26 0 .26.26 0 0 0 .13-.22v-.54a1 1 0 0 1 1.63-.77l4.21 3.44a1 1 0 0 1 0 1.55"
    }, null, -1)
  ]));
}
const entertainmentControlButtonCircleRightArrowFastForward = { render };
export {
  entertainmentControlButtonCircleRightArrowFastForward as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-right-arrow-fast-forward.svg.js.map
